"use client";
import { type ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

const TOP_BAR_SLOT_ID = "top-bar-slot";

export function TopBarSlot() {
  return <div id={TOP_BAR_SLOT_ID} />;
}

export function TopBarPortal({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setSlot(document.getElementById(TOP_BAR_SLOT_ID));
  }, []);

  return slot ? createPortal(children, slot) : null;
}
